"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  chain: true,
  createParser: true,
  many: true,
  matchTokenType: true,
  optional: true,
  plus: true,
  Scanner: true
};
Object.defineProperty(exports, "chain", {
  enumerable: true,
  get: function get() {
    return _chain.chain;
  }
});
Object.defineProperty(exports, "createParser", {
  enumerable: true,
  get: function get() {
    return _chain.createParser;
  }
});
Object.defineProperty(exports, "many", {
  enumerable: true,
  get: function get() {
    return _match.many;
  }
});
Object.defineProperty(exports, "matchTokenType", {
  enumerable: true,
  get: function get() {
    return _match.matchTokenType;
  }
});
Object.defineProperty(exports, "optional", {
  enumerable: true,
  get: function get() {
    return _match.optional;
  }
});
Object.defineProperty(exports, "plus", {
  enumerable: true,
  get: function get() {
    return _match.plus;
  }
});
Object.defineProperty(exports, "Scanner", {
  enumerable: true,
  get: function get() {
    return _scanner.Scanner;
  }
});

var _chain = require("./chain");

var _match = require("./match");

var _scanner = require("./scanner");

var _define = require("./define");

Object.keys(_define).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _define[key];
    }
  });
});